import { render, staticRenderFns } from "./chateau-climens.vue?vue&type=template&id=4049a36d&scoped=true"
import script from "./chateau-climens.vue?vue&type=script&lang=js"
export * from "./chateau-climens.vue?vue&type=script&lang=js"
import style0 from "./chateau-climens.vue?vue&type=style&index=0&id=4049a36d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4049a36d",
  null
  
)

export default component.exports